import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { TabDetection } from '@app/tab-detection/tab-detection-service/tab-detection';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'esignatur-tab-detection-warning',
  imports: [TranslocoPipe],
  templateUrl: './tab-detection-warning.html',
  styleUrl: './tab-detection-warning.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabDetectionWarning {
  readonly #tabService = inject(TabDetection);

  /** Active tab count */
  readonly activeTabCount = this.#tabService.activeTabCount;

  /** Custom message from config */
  readonly message = computed(
    () => this.#tabService.config().customMessage || 'This website is already open in another tab'
  );

  /** Current tab ID (truncated for display) */
  readonly tabId = computed(() => this.#tabService.getTabId().slice(0, 8));
}
